<template>
    <div class="board-container">
        <div class="board-search">
            <div class="board-search__box">
                <input v-model="filter.searchValue" class="board-search__input" type="text" name="" value="" @keydown.enter="getQuestions" />
                <button class="board-search__button" type="submit" name="button" @click="getQuestions"></button>
            </div>
            <div class="board-search__select">
                <select v-model="filter.type" class="board-search__selectbox" name="" @input="getQuestions">
                    <option value="" disabled selected>문의항목을 선택해주세요.</option>
                    <option v-for="type in questionTypes" :key="type" :value="type">{{ type }}</option>
                </select>
            </div>
        </div>
        <div role="table" class="board-table board-table--inquiry">
            <div role="rowgroup">
                <div role="row">
                    <div role="columnheader" class="num">번호</div>
                    <div role="columnheader" class="title">문의사항</div>
                    <div role="columnheader" class="cell">문의유형</div>
                    <div role="columnheader" class="cell">답변상태</div>
                    <div role="columnheader" class="cell">작성일</div>
                </div>
            </div>
            <div v-for="(question, index) in questions" :key="question._id">
                <div role="rowgroup">
                    <div role="row">
                        <div role="cell" class="num">{{ (page - 1) * limit + index + 1 }}</div>
                        <div role="cell" class="title">
                            <div class="title">
                                <a role="link" @click="$router.push({ query: { _question: question._id } })">{{ question.subject }}</a>
                            </div>
                        </div>
                        <div role="cell" class="cell type">{{ question.type }}</div>
                        <div role="cell" class="cell state">
                            <span v-if="question.reply">답변완료</span>
                            <span v-else>미답변</span>
                        </div>
                        <div role="cell" class="cell date">
                            <span class="date">{{ question.createDate.toDate() }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <pagination-component v-model="page" :count="pageCount" @input="search" />

        <div class="board-buttons">
            <!-- <a class="button button--border" href="#"><span>리스트</span></a> -->
            <a class="button button--primary" @click="write"><span>글쓰기</span></a>
        </div>
    </div>
</template>

<script>
import PaginationComponent from "@/components/client/control/pagination-component.vue";
export default {
    components: {
        PaginationComponent,
    },
    data: () => {
        return {
            filter: {
                searchKey: "subject",
                searchValue: "",
                type: "",
            },

            page: 1,
            pageCount: 0,
            limit: 20,

            questions: [],
            questionTypes: ["회원정보 문의", "주문/결제 문의", "상품 문의", "배송 문의", "교환/반품 문의", "이벤트/혜택 문의", "서비스 개선 의견", "기타문의"],
        };
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                await this.getQuestions();

                this.$nextTick(() => {
                    // 문의내역 - 답변 토글
                    (function() {
                        let question = document.querySelectorAll('.board-table--inquiry [role="button"]'),
                            answer = document.querySelectorAll('.board-table--inquiry [role="rowgroup"].answer');

                        for (let i = 0; i < question.length; i++) question[i].addEventListener("click", toggleInquiry);

                        function toggleInquiry() {
                            let idx = this.getAttribute("data-idx"),
                                toggle = document.querySelector('.board-table--inquiry [role="rowgroup"][data-idx-answer="' + idx + '"]');

                            if (toggle !== null) {
                                if (toggle.getAttribute("data-answer") === "opened") {
                                    for (let i = 0; i < answer.length; i++) answer[i].removeAttribute("data-answer");
                                } else {
                                    for (let i = 0; i < answer.length; i++) answer[i].removeAttribute("data-answer");
                                    toggle.setAttribute("data-answer", "opened");
                                }
                            }
                        }
                    })();
                });
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message);
            }
        },

        write() {
            this.$router.push({
                name: this.$route.name,
                query: {
                    _question: null,
                },
            });
        },

        async search() {
            try {
                await this.getQuestions();
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message);
            }
        },

        getQuestions() {
            return new Promise(async (resolve, reject) => {
                try {
                    var res = await this.$http.get("/api/v1/center/questions", {
                        headers: {
                            skip: (this.page - 1) * this.limit,
                            limit: this.limit,
                        },
                        params: this.filter,
                    });

                    this.pageCount = Math.ceil(res.data.summary.totalCount / this.limit);
                    this.questions = res.data.questions;

                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.title {
    width: 60% !important;
}
</style>
